"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Mon317CarouselData = _interopRequireDefault(require("pricing-pages-unified-ui/components/cms-hub-page/Mon317CarouselData"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("HubStyleTokens/colors");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-radius: 4px;\n  overflow: hidden;\n  max-height: 100%;\n  margin: auto 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 90vw;\n  height: calc(100vh - 120px);\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  * {\n    background-color: transparent !important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TransparentModal = (0, _styledComponents.default)(_UIModal.default).withConfig({
  displayName: "Mon317CarouselModal__TransparentModal",
  componentId: "o0llgt-0"
})(_templateObject());

var ModalInner = _styledComponents.default.div.withConfig({
  displayName: "Mon317CarouselModal__ModalInner",
  componentId: "o0llgt-1"
})(_templateObject2());

var RoundedImage = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "Mon317CarouselModal__RoundedImage",
  componentId: "o0llgt-2"
})(_templateObject3());

var Mon317CarouselModal = function Mon317CarouselModal(_ref) {
  var open = _ref.open,
      screenshotIndex = _ref.screenshotIndex,
      closeModal = _ref.closeModal;
  if (!open) return null;
  return _react.default.createElement(TransparentModal, {
    width: "90vw"
  }, _react.default.createElement(ModalInner, null, _react.default.createElement(RoundedImage, {
    src: _Mon317CarouselData.default[screenshotIndex].screenshot2X
  }), _react.default.createElement(_UIIcon.default, {
    name: "remove",
    size: "medium",
    style: {
      color: _colors.OLAF,
      cursor: 'pointer',
      marginBottom: 'auto'
    },
    className: "m-left-3",
    onClick: closeModal
  })));
};

Mon317CarouselModal.propTypes = {
  open: _propTypes.default.bool.isRequired,
  screenshotIndex: _propTypes.default.number.isRequired,
  closeModal: _propTypes.default.func.isRequired
};
var _default = Mon317CarouselModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/cms-hub-page/Mon317CarouselModal.js
// module id = 886
// module chunks = 5 6